export const CHANGE_FCM_TOKEN = "CHANGE_FCM_TOKEN";

export function changeFcmToken(fcmToken) {
  return {
    fcmToken,
    type: CHANGE_FCM_TOKEN
  };
}
